import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import {
  createDateField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum PayoutsDetailPageFilterKeys {
  orderDate = "orderDate",
  completedAt = "completedAt",
  paymentMethodType = "paymentMethodType",
  settlementDate = "settlementDate"
}
export interface PayoutsDetailsPageFilterOpts {
  orderDate: FilterOpts<MinMax>;
  completedAt: FilterOpts<MinMax>;
  paymentMethodType: FilterOpts<string>;
  settlementDate: FilterOpts<MinMax>;
}

export enum paymentEnum {
  card = "card",
  cash = "cash"
}
const messages = defineMessages({
  card: {
    defaultMessage: "CARD",
    description: "card"
  },
  cash: {
    defaultMessage: "CASH",
    description: "cash"
  },
  completedAt: {
    defaultMessage: "Order Completion Date",
    description: "order completion date"
  },
  orderDate: {
    defaultMessage: "Order Created Date",
    description: "order created date"
  },
  paymentMethodType: {
    defaultMessage: "Payment Method",
    description: "payment method"
  },
  settlementDate: {
    defaultMessage: "Settlement Date",
    description: "settlement date"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: PayoutsDetailsPageFilterOpts,
  isTreasury: boolean
): IFilter<PayoutsDetailPageFilterKeys> {
  const filter = isTreasury
    ? [
        {
          ...createDateField(
            PayoutsDetailPageFilterKeys.settlementDate,
            intl.formatMessage(messages.settlementDate),
            opts.settlementDate.value
          ),
          active: opts.settlementDate.active
        }
      ]
    : [
        {
          ...createDateField(
            PayoutsDetailPageFilterKeys.orderDate,
            intl.formatMessage(messages.orderDate),
            opts.orderDate.value
          ),
          active: opts.orderDate.active
        },
        {
          ...createDateField(
            PayoutsDetailPageFilterKeys.completedAt,
            intl.formatMessage(messages.completedAt),
            opts.completedAt.value
          ),
          active: opts.completedAt.active
        },
        {
          ...createOptionsField(
            PayoutsDetailPageFilterKeys.paymentMethodType,
            intl.formatMessage(messages.paymentMethodType),
            [opts.paymentMethodType.value],
            false,
            [
              {
                label: intl.formatMessage(messages.card),
                value: paymentEnum.card
              },
              {
                label: intl.formatMessage(messages.cash),
                value: paymentEnum.cash
              }
            ]
          ),
          active: opts.paymentMethodType.active
        }
      ];

  return filter;
}
